// extracted by mini-css-extract-plugin
export default {"list-item":"lsf-list-item","list-item__title":"lsf-list-item__title","list-item__counter":"lsf-list-item__counter","list-item__visibility":"lsf-list-item__visibility"};
    if(module.hot) {
      // 1732531527856
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  